"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));

var SnackbarContent_1 = __importDefault(require("@material-ui/core/SnackbarContent"));

var styles_1 = require("@material-ui/core/styles");

var alert_error_svg_1 = __importDefault(require("../assets/images/alert-error.svg"));

var bb8_success_svg_1 = __importDefault(require("../assets/images/bb8-success.svg"));

var close_svg_1 = __importDefault(require("../assets/images/close.svg"));

var warning_orange_svg_1 = __importDefault(require("../assets/images/warning-orange.svg"));

var VariantIcon = {
  error: function error(_a) {
    var classes = _a.classes;
    return react_1.default.createElement("img", {
      className: classes.iconVariant,
      src: alert_error_svg_1.default
    });
  },
  info: function info(_a) {
    var classes = _a.classes;
    return react_1.default.createElement("img", {
      className: classes.iconVariant,
      src: close_svg_1.default
    });
  },
  success: function success(_a) {
    var classes = _a.classes;
    return react_1.default.createElement("img", {
      className: classes.iconVariant,
      src: bb8_success_svg_1.default
    });
  },
  warning: function warning(_a) {
    var classes = _a.classes;
    return react_1.default.createElement("img", {
      className: classes.iconVariant,
      src: warning_orange_svg_1.default
    });
  }
};

var snackbarContentStyles = function snackbarContentStyles(theme) {
  return styles_1.createStyles({
    closeIcon: {
      backgroundImage: 'url(' + require('../assets/images/close.svg') + ')',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '8px',
      fontSize: 20
    },
    error: {
      backgroundColor: theme.palette.error.light
    },
    iconVariant: {
      marginRight: theme.spacing.unit * 2,
      opacity: 0.9
    },
    info: {
      backgroundColor: theme.palette.secondary.dark
    },
    message: {
      alignItems: 'center',
      color: '#3A3733',
      display: 'flex'
    },
    root: {
      borderRadius: '2px',
      marginBottom: '16px'
    },
    success: {
      backgroundColor: theme.palette.alert.success
    },
    warning: {
      backgroundColor: theme.palette.status.warning
    }
  });
};
/**
 * Wrapper for material-ui alert component. for more details see https://material-ui.com/demos/snackbars/
 * @param props
 */


function BB8SnackbarContent(props) {
  var classes = props.classes,
      className = props.className,
      message = props.message,
      onClose = props.onClose,
      variant = props.variant,
      other = __rest(props, ["classes", "className", "message", "onClose", "variant"]);

  var AlertIcon = VariantIcon[variant];
  return react_1.default.createElement(SnackbarContent_1.default, __assign({
    className: classnames_1.default(classes.root, classes[variant], className),
    "aria-describedby": "client-snackbar",
    message: react_1.default.createElement("span", {
      id: "client-snackbar",
      className: classes.message
    }, react_1.default.createElement(AlertIcon, {
      classes: classes
    }), message),
    action: [react_1.default.createElement(IconButton_1.default, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      className: classes.close,
      onClick: onClose
    }, react_1.default.createElement(core_1.Icon, {
      className: classes.closeIcon
    }))]
  }, other));
}

var BB8SnackbarContentWrapper = styles_1.withStyles(snackbarContentStyles)(BB8SnackbarContent);

var snackbarStyles = function snackbarStyles(theme) {
  return styles_1.createStyles({
    margin: {
      margin: theme.spacing.unit
    }
  });
};

var cache = [];

function jsonReplacer(key, value) {
  if (typeof value === 'object' && value !== null) {
    if (cache.indexOf(value) !== -1) {
      // Duplicate reference found
      try {
        // If this value does not reference a parent it can be deduped
        return JSON.parse(JSON.stringify(value));
      } catch (error) {
        // discard key if value cannot be deduped
        return;
      }
    } // Store value in our collection


    cache.push(value);
  }

  return value;
}
/**
 * Tries to parse the error message and display something meaningful
 * @param message any error message in any format
 */


function messageParser(message) {
  cache = [];

  if (!message) {
    return '';
  }

  if (typeof message === 'string') {
    return message;
  }

  if (typeof message === 'object') {
    if (Array.isArray(message)) {
      return message.map(messageParser).join(' | ');
    }

    if (message instanceof Error) {
      return message.name + " " + message.message;
    }

    return JSON.stringify(message, jsonReplacer, 2);
  }

  return message.toString();
}

function BB8Alert(_a) {
  var autoHideDuration = _a.autoHideDuration,
      message = _a.message,
      onClose = _a.onClose,
      variant = _a.variant,
      show = _a.show;
  var innerMessage = message instanceof Error ? message.message : message;
  return react_1.default.createElement(Snackbar_1.default, {
    anchorOrigin: {
      horizontal: 'center',
      vertical: 'bottom'
    },
    open: show,
    autoHideDuration: autoHideDuration,
    onClose: onClose
  }, react_1.default.createElement(BB8SnackbarContentWrapper, {
    className: "bb8-snackbar-content-wrapper",
    onClose: onClose,
    variant: variant,
    message: messageParser(innerMessage)
  }));
}

exports.default = styles_1.withStyles(snackbarStyles)(BB8Alert);